<template>
  <div v-if="comming_soon && $route.name == 'Home Page'">
    <MobileHeader class="d-md-none" />
    <!-- <MobileHeader /> -->
    <Header />
    <br />
    <div style="margin-top: 120px;margin-bottom: 120px;text-align: center;">
      <h1 class="font-weight-bold">COMING SOON</h1>
    </div>
    <br />
    <Footer />
  </div>

  <div v-else id="app">
    <allModalHeader />
    <MobileHeader class="d-md-none" />
    <!-- <MobileHeader /> -->
    <Header />

    <!-- :time="Day 2 * Hours 24  * Minutes 60 * Seconds 60 * milliseconds 1000" -->
    <!-- <countdown :time="2 * 60 * 1000" :disabled="counting" tag="p" @end="handleCountdownEnd">
      <template
        slot-scope="props"
      >Time Remaining：{{ props.days }} days, {{ props.hours }} hours, {{ props.minutes }} minutes, {{ props.seconds }} seconds.</template>
    </countdown>-->

    <main class="jm-main">
      <transition
        :enter-active-class="WithTransitionEnterActive"
        :leave-active-class="WithTransitionleaveActive"
      >
        <!-- :enter-active-class="'animated slideInRight'"
        :leave-active-class="'animated slideOutLeft'"-->
        <router-view />
      </transition>
    </main>
    <Footer />

    <!-- MODALS -->
    <custom />
    <login />
    <signup />
    <otp />
    <forgotPassword />
    <verification />
    <selectCity />
    <selectCinema />
    <safetyPopup />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import enquireScreen from "@/utils/device/device";
import cookieType from "@/config/cookieType";
import Header from "@/components/partials/header.vue";
import Footer from "@/components/partials/footer.vue";
import Vue from "vue";
import MobileHeader from "@/components/partials/mobileHeader.vue";
import allModalHeader from "@/components/modals/allModalHeader.vue";

import custom from "@/components/modals/custom.vue";
import login from "@/components/modals/login.vue";
import signup from "@/components/modals/signup.vue";
import otp from "@/components/modals/otp.vue";
import forgotPassword from "@/components/modals/forgotPassword.vue";
import verification from "@/components/modals/verification.vue";
import selectCity from "@/components/modals/selectCity.vue";
import selectCinema from "@/components/modals/selectCinema.vue";
import safetyPopup from "@/components/modals/safetyPopup.vue";
import { comming_soon } from "@/config";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    MobileHeader,
    allModalHeader,
    custom,
    login,
    signup,
    otp,
    forgotPassword,
    verification,
    selectCity,
    selectCinema,
    safetyPopup,
  },
  data() {
    return {
      comming_soon,
    };
  },
  computed: {
    WithTransitionEnterActive() {
      // return this.$store.getters.getWithTransition;
      return this.$store.state.AppSetting.isMobile
        ? this.$store.state.AppSetting.withTransition.enterActive
        : "";
    },
    WithTransitionleaveActive() {
      return this.$store.state.AppSetting.isMobile
        ? this.$store.state.AppSetting.withTransition.leaveActive
        : "";
    },
    ...mapGetters(["getWithTransition", "getLocation"]),
    ...mapState({}),
  },
  created() {
    let _this = this;
    enquireScreen((isMobile) => {
      _this.$store.commit("AppSetting/SETDEVICE", isMobile);
    });
  },
  beforeMount() {},
  mounted() {
    // this.setUserName({ name: "SAIF" });
    // if (!this.getLocation) {
  },

  methods: {
    ...mapActions(["setUserName", "onHandleOpenModal"]),
  },
  beforeDestroy() {},
};
</script>

<style>
.section-loader {
  width: 100%;
  text-align: center;
  user-select: none;
  padding-top: 15px;
  padding-bottom: 15px;
}

.section-loader .spinner-border {
  height: 17px;
  width: 17px;
  border: 2px solid var(--rose-gold);
  border-right-color: #fff;
}

.section-loader label {
  opacity: 0.5;
  color: #000;
  font-size: 16px;
  padding-left: 5px;
  position: relative;
  top: 1px;
  line-height: 1;
  margin-bottom: 0;
}

.section-empty-state {
  padding: 50px;
  position: relative;
  border-top: 1px dashed #d3d3d3;
}
</style>



// WEBPACK FOOTER //
// src/App.vue